import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { Button } from "../button";

function WarningModal({ isOpen, onClose, onConfirm, sourceWeek, targetWeek }) {
  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white dark:bg-gray-800 px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                <div className="flex items-center justify-center w-full h-full">
                  <div className="bg-white dark:bg-gray-800 rounded-lg p-6 max-w-md w-full mx-4">
                    <div className="flex items-center mb-4">
                      <ExclamationTriangleIcon className="h-6 w-6 text-yellow-500 mr-3" />
                      <h3 className="text-lg font-medium text-gray-900 dark:text-white">
                        Replace Existing Schedule
                      </h3>
                    </div>

                    <div className="mb-6">
                      <p className="text-sm text-gray-600 dark:text-gray-300 mb-4">
                        Copying from{" "}
                        <span className="font-medium">{sourceWeek}</span> will
                        replace all existing shifts in{" "}
                        <span className="font-medium">{targetWeek}</span>.
                      </p>
                      <p className="text-sm text-gray-600 dark:text-gray-300">
                        This action cannot be undone.
                      </p>
                    </div>

                    <div className="flex justify-start space-x-3">
                      <Button onClick={onConfirm}>Replace</Button>
                      <Button variant="link" onClick={onClose}>
                        Cancel
                      </Button>
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}

export { WarningModal };
